import { Modal, Image } from 'antd';
import { useState } from 'react';
import './view-photo.scss';

interface IViewPhotoProps {
  photoUrl: string;
}

const ViewPhoto = ({ photoUrl }: IViewPhotoProps) => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <div className="view-photo-wrapper">
      <Image src={photoUrl} preview={false} onClick={() => setPreviewOpen(true)} />
      <Modal open={previewOpen} footer={null} onCancel={() => setPreviewOpen(false)}>
        <img alt="pet-img" style={{ width: '100%' }} src={photoUrl} />
      </Modal>
    </div>
  );
};

export default ViewPhoto;
